import { useState, useContext } from "react";
import styles from "./Promocode.module.css"
import LoadingComponent from "../../../UI/LoadingComponent/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Context } from "../../../../index";
import UserService from "../../../../service/UserService";
import ErrorComponent from "../../../UI/Error/ErrorComponent";
import Choice from "../Choice/Choice";
import { Modal } from "antd";
function Promocode({ props,closeModal }) {
    const [loading_state, setLoading_state] = useState(false)
    const [stateModal, setStateModal] = useState(false);
    const [name, setName] = useState("")
    const { store } = useContext(Context)
    async function accept() {
        try {
            const response = props.current_type_promocode === "promocode" ? await UserService.UsePromocode(name) : await UserService.UseVaucher(name);
            if (response.data.err) {
                store.add_message(response.data.err, ErrorComponent)
                setStateModal(false)
                
            }
            else {
                closeModal();
                if (response.data.modal) {
                    store.set_modal(response.data.modal)

                }
                await props.handleOk();

            }
        }
        catch (e) {
            console.error(e)
        }
        finally {
            setLoading_state(false)
        }
    }
    return (
        <>
            {stateModal ? <Choice props={{
                    handleClick: async (type) => accept(),
                    handleClose: ()=> closeModal(),
                    type: props.current_type_promocode,
                    text: "При активации нового бонуса сгорает действующий активный бонус (если такой есть)"
                }} /> : <div className={styles.model_box}>
                
                {loading_state ? <LoadingComponent /> : (
                    <>
                        <span></span>
                        <span></span>
                        <span></span>
                        <form>

                            <label>{props.current_type_promocode === "promocode" ? store.dataLang["enter_promocode_modal"] : "Введите название ваучера"}</label>

                            <input onChange={e => setName(e.target.value)} className="login_input" type="" />
                            <div className={styles.wrapperButtons}>
                                <button onClick={async () => {


                                    setStateModal(true)
                                }} disabled={loading_state} type="button"
                                    className={`wallet_nav_bar skeleton-button ${styles.buttonAccept}`}>{store.dataLang["confirm_name"]}
                                </button>

                            </div>

                        </form>
                    </>
                )}

            </div>}

        </>
    )
}
export default observer(Promocode)